import Swal from "sweetalert2";
import { findNewerOpenedAt } from "~~/modules/pos/utils/businessSession";

/**
 * เครื่องนี้ถือ OPEN ของรอบการขายที่ปิดไปแล้วหรือไม่ (ดู modules/pos/utils/businessSession.ts)
 * ใช้ทั้งหน้าจอแจ้งเตือน (ModalSessionStale) และด่านชำระเงิน
 *
 * ข้อความบอกเป็น "เวลาเปิดร้าน" ไม่ใช่แค่วันที่ เพราะปิดแล้วเปิดใหม่ในวันเดียวกันก็นับเป็นคนละรอบ
 */
export const useSessionStale = () => {
  const jobsStore = useJobsStore();
  const format = (value) => (value ? useDisplayDate(value, "DD/MMM HH:mm") : "");

  const openedAtLabels = () => ({
    mine: format(jobsStore.openShop?.timestamp),
    current: format(findNewerOpenedAt(jobsStore.openShop, jobsStore.businessSession)),
  });

  const reload = () => {
    window.location.href = "/";
  };

  /**
   * ด่านก่อนชำระเงิน คืน true = ค้างรอบเก่า ห้ามจ่าย (ขึ้น alert ให้โหลดใหม่แล้ว)
   * ไม่มีปุ่มข้าม ต้องโหลดใหม่ให้ได้ openShop ของรอบปัจจุบันก่อนเท่านั้น
   */
  const blockIfStale = (): boolean => {
    if (!jobsStore.isSessionStale) return false;

    const t = useNuxtApp().$i18n.t;
    const { mine, current } = openedAtLabels();
    const lines = [t("pos.main.session_stale.label.mine", { openedAt: mine })];
    if (current) lines.push(t("pos.main.session_stale.label.current", { openedAt: current }));
    lines.push(t("pos.main.session_stale.label.reload_before_pay"));

    Swal.fire({
      icon: "error",
      title: t("pos.main.session_stale.label.cannot_pay"),
      html: lines.map((line) => `<p>${line}</p>`).join(""),
      confirmButtonText: t("pos.main.session_stale.btn.reload"),
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(reload);

    return true;
  };

  return { openedAtLabels, reload, blockIfStale };
};
